module.exports = __webpack_public_path__ + "media/svg-new/avatar-23 2-7cd115ab.svg";